import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Plano } from '../models/plano.model';
import { createCampanhaFormDefaultValue } from '../models/campanha-form.model';
import { campanhaDestinoValidator } from '../validators/campanha-destino.validator';
import { campanhaPerfilPadraoValidator } from '../validators/campanha-perfil-padrao.validator';
import { campanhaVigenciaValidator } from '../validators/campanha-vigencia.validator';
import { campanhaPlanosValidator } from './campanha-planos.validator';

export function createCampanhaFormGroup(fb: FormBuilder): FormGroup {
  const defaults = createCampanhaFormDefaultValue();

  return fb.nonNullable.group({
    nome: [defaults.nome, [Validators.required, Validators.maxLength(50)]],
    nomeExibicao: defaults.nomeExibicao,
    descricao: [defaults.descricao, [Validators.required, Validators.maxLength(800)]],
    instrucoes: [defaults.instrucoes, Validators.required],
    dataInicio: [defaults.dataInicio, Validators.required],
    dataFim: [defaults.dataFim, Validators.required],
    horarioInicio: [defaults.horarioInicio, Validators.required],
    horarioFim: [defaults.horarioFim, Validators.required],
    participanteDataInicio: [defaults.participanteDataInicio, Validators.required],
    participanteHorarioInicio: defaults.participanteHorarioInicio,
    dtIntegracao: defaults.dtIntegracao,
    selecionarTodosPlanos: defaults.selecionarTodosPlanos,
    planosAdicionados: fb.nonNullable.control<Plano[]>(defaults.planosAdicionados),
    // Removido por solicitação do PO — manter comentado.
    // permitirReopcao: defaults.permitirReopcao,
    exibeTermo: defaults.exibeTermo,
    // tipoTermo é UI-only (ver comentário em CampanhaFormValue): sem validator porque o
    // catálogo tem uma única opção e não há nada da API para validar contra.
    tipoTermo: defaults.tipoTermo,
    // Removido por solicitação do PO — manter comentado.
    // importacaoObrigatoria: defaults.importacaoObrigatoria,
    tipoDestino: [defaults.tipoDestino, Validators.required],
    destinoId: defaults.destinoId,
    idPerfilInvestimentoDef: defaults.idPerfilInvestimentoDef,
    linkCampanha: defaults.linkCampanha,
  }, {
    validators: [
      campanhaPlanosValidator(),
      campanhaDestinoValidator(),
      campanhaPerfilPadraoValidator(),
      campanhaVigenciaValidator(),
    ],
  });
}
